import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const marqueeDefaultVariants = {
  "vertical": false,
  "reverse": false,
  "pauseOnHover": false
}
const marqueeCompoundVariants = []

const marqueeSlotNames = [
  [
    "root",
    "marquee__root"
  ],
  [
    "track",
    "marquee__track"
  ]
]
const marqueeSlotFns = /* @__PURE__ */ marqueeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, marqueeDefaultVariants, getSlotCompoundVariant(marqueeCompoundVariants, slotName))])

const marqueeFn = memo((props = {}) => {
  return Object.fromEntries(marqueeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const marqueeVariantKeys = [
  "vertical",
  "reverse",
  "pauseOnHover"
]
const getVariantProps = (variants) => ({ ...marqueeDefaultVariants, ...compact(variants) })

export const marquee = /* @__PURE__ */ Object.assign(marqueeFn, {
  __recipe__: false,
  __name__: 'marquee',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: marqueeVariantKeys,
  variantMap: {
  "vertical": [
    "true",
    "false"
  ],
  "reverse": [
    "true",
    "false"
  ],
  "pauseOnHover": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, marqueeVariantKeys)
  },
  getVariantProps
})